'use strict';

import axios from "axios";

/*
 * Displays specific post by sidebar selection
 */
class SelectPostFromSidebar {

    // instantiate object
    constructor() {
        // 'sidebarContainer' used as anchor element for event listener
        // if no heading-sidebar element found, return immediately (e.g. in case of "play flexbox")
        this.sidebarContainer = document.querySelector('.sidebar-container');

        if (this.sidebarContainer == null) 
            return;

        this.allSidebarHeadings = document.querySelectorAll('.heading-sidebar');
        /*
         * If also "empty" cats shall be shown, 'hide_empty' must be set to 'false'
         * in get_categories()
         */
        // return if no heading-elements found
        // if (this.allSidebarHeadings.length == 0) 
        //    return;

        this.currentSidebarItem = null;

        this.events();
    }

    // event listeners
    events() {
        this.sidebarContainer.addEventListener('click', e => {
            e.preventDefault();

            if (this.currentSidebarItem == e.target) {
                //no change
                return;
            } else {
                this.currentSidebarItem = e.target;
            }

            this.highlightSidebarItem();
            this.getSinglePost();
        });
    }

    // methods
    highlightSidebarItem() {

        this.allSidebarHeadings.forEach(heading =>
            heading.classList.remove('heading-sidebar--active')
        );
        this.currentSidebarItem.classList.add('heading-sidebar--active');
    };

    async getSinglePost() {

        const contentContainer = document.querySelector('.content-container');

        // remove old content
        contentContainer.innerHTML = '';

        const siteURL = this.getSiteURL();

        const postID = Number(this.currentSidebarItem.dataset.postId);

        try {

            const response = await axios.get(`${siteURL}${postID}`);
            const results = response.data;

            contentContainer.insertAdjacentHTML(
                "afterbegin",
                `<div class="post-item">
                    ${results.content.rendered}
                 </div>
                `
            );

        } catch(e) {
            console.log(e);
        }
    }

    // helper
    getSiteURL() {
        /*
         * Alternative: pass current URL from WP PHP to JS using "wp_localize_script"
         *
         * Should convert urls like e.g.
         *          http://localhost:8000/development/wordpress to
         *          http://localhost:8000/wp-json/wp/v2/posts/
         *
         * myArray after split: ['http:', '', 'localhost:8000', 'development', 'wordpress', '']
         * 
         * Use
         *      myArray[0] ==> http vs https
         *      myArray[2] ==> domain name
         */
        const myArray = document.URL.split('/');

        return myArray[0] + '//' + myArray[2] + '/wp-json/wp/v2/posts/';
    }
}

export default SelectPostFromSidebar;
